import { FunctionComponent, useState } from 'react'
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap'
import Icon from 'components/ui/icon'

import { stringNullOrEmpty } from '../../../utilities/string.util'

type NewAdmin = { name: string; email: string }

const emptyAdmin: NewAdmin = { name: '', email: '' }

type HospitalAdminModalProps = {
  onClose: () => void
  /** Rejects with the API error when the admin could not be added. */
  onAdd: (admin: NewAdmin) => Promise<void>
}

const HospitalAdminModal: FunctionComponent<HospitalAdminModalProps> = ({
  onClose,
  onAdd,
}) => {
  const [admin, setAdmin] = useState(emptyAdmin)
  const [creating, setCreating] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()

  const isValid = !stringNullOrEmpty(admin.name) && !stringNullOrEmpty(admin.email)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    setAdmin({ ...admin, [name]: value })
  }

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (!isValid) {
      return
    }

    setCreating(true)
    setErrorMessage(undefined)

    try {
      await onAdd(admin)
    } catch (error) {
      setErrorMessage(
        `Erro ao adicionar o administrador do hospital: ${(
          error as any
        ).messages.join(', ')}`
      )
    } finally {
      setCreating(false)
    }
  }

  return (
    <Modal show onHide={onClose} centered>
      <Form onSubmit={submit}>
        <Modal.Header closeButton>
          <Modal.Title>Adicionar administrador</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
          <div className="form-grid">
            <Form.Group controlId="adminName">
              <Form.Label>Nome</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={admin.name}
                onChange={handleChange}
                autoFocus
                required
              />
            </Form.Group>
            <Form.Group controlId="adminEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="text"
                name="email"
                value={admin.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={!isValid || creating}>
            {creating ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <Icon name="plus" size={16} />
            )}
            Adicionar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default HospitalAdminModal
